define('uikit/elements/input',['require','exports','module','underscore','marionette','../channel','../mixins/component.mixin','./button','templates','../extra/size','autosize'],function(require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var channel = require('../channel');
  var ComponentMixin = require('../mixins/component.mixin');
  var ButtonView = require('./button');
  var Templates = require('templates');
  var Size = require('../extra/size');
  var autosize = require('autosize');

  var Input = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui input',

    template: Templates.App['input'],

    events: {
      'keydown input,textarea': function(ev) {
        var self = this;
        _.defer(function() {
          // If i use key down and defer it, i can get the data a little
          // bit quicker.. i dont have to wait for the key to move up before
          // i do something
          self.triggerMethod('before:key:code', ev.keyCode || ev.which);
          self._setOption('value', self.ui.input.val(), { internal: true });
          self.triggerMethod('key:code', ev.keyCode || ev.which);
        });
      },
      'paste input,textarea': function(ev) {
        var self = this;
        _.defer(function() {
          self._setOption('value', self.ui.input.val(), { internal: true });
        });
      },
      'input input,textarea': function(ev) {
        var self = this;
        _.defer(function() {
          self._setOption('value', self.ui.input.val(), { internal: true });
        });
      },
    },

    triggers: {
      'focus input, textarea': {
        preventDefault: false,
        event: 'focus',
      },
      'blur input, textarea': 'blur',
    },

    ui: {
      input: 'input, textarea',
    },

    internalViews: {
      button: ButtonView,
    },

    //prettier-ignore
    options: {
      inputId               : '',
      required              : false,
      visible               : true,
      inputType             : 'text',
      inputAutocomplete     : false,
      value                 : '',
      placeholder           : '',
      icon                  : null,
      iconRight             : false,
      error                 : false,
      loading               : false,
      label                 : null,
      labelRight            : false,
      transparent           : false,
      size                  : '',
      focusable             : true,
      readonly              : false,
      fluid                 : false,
      buttonRight           : true,
      button                : null,
      disabled              : false,
      saveEmptyStringAsNull : true,
      maxLength             : null,
      typeAheadFind         : false,
      // only applies to multiLine
      rowCount              : 1,
      multiLine             : false
    },

    inputTypeOptionValues: ['text', 'password'],
    sizeOptionValues: _.values(Size),

    forceUpdate: {
      inputType: true,
      inputAutocomplete: true,
      placeholder: true,
      icon: true,
      iconRight: true,
      error: true,
      label: true,
      labelRight: true,
      transparent: true,
      size: true,
      focusable: true,
      fluid: true,
      buttonRight: true,
      button: true,
      disabled: true,
      maxLength: true,
      rowCount: true,
      multiLine: true,
    },

    bindings: {},

    focus: function() {
      if (!_.isEmpty(this.ui.input)) {
        this.ui.input.focus();
      }
      return this;
    },

    onRender: function() {
      var self = this;

      if (this.multiLine) {
        _.defer(function() {
          autosize(self.ui.input);
        });
      }
    },

    onFirstRender: function() {
      var self = this;
      this
        // re-rendering the entire view when the value
        // change can have un-wanted side effects
        .on('change:value', function(selfView, currentValue, prev, options) {
          if (self.getOption('saveEmptyStringAsNull') && _.isString(self.value) && self.value.length === 0) {
            self._setOption('value', null, { internal: true });
          }

          if (!_.result(options, 'internal')) {
            self.ui.input.val(self.value);
          }

          if (self.getOption('typeAheadFind')) {
            self.triggerMethod('typeahead:change:value', currentValue);
          }
        });

      this.on('change:visible', function() {
        if (this.visible && this.multiLine && this.autosize) {
          _.defer(function() {
            autosize.update(self.ui.input);
          });
        }
      });

      if (this.getOption('typeAheadFind')) {
        this.on('blur', function() {
          self.triggerMethod('typeahead:blur');
        }).on('before:key:code', function(keycode) {
          self.triggerMethod('typeahead:key:down', keycode);
        });
      }

      this.ui.input.val(this.value);
    },

    updateAttributes: function() {
      // we canot have a button and an icon on the left
      var iconLeft =
          !this.getBoolOption('iconRight') && (this.getBoolOption('buttonRight') || !this.getOption('button')),
        button = this.button;

      this.addClass(this.getOption('size'), this.getBoolOption('size'))
        .addClass('transparent', this.getBoolOption('transparent'))
        .addClass('left', iconLeft && this.getBoolOption('icon'))
        .addClass('icon', this.getBoolOption('icon'))
        .addClass('loading', this.getBoolOption('loading'))
        .addClass('error', this.getBoolOption('error'))
        .addClass('right', this.getBoolOption('labelRight') && this.getBoolOption('label'))
        .addClass('labeled', this.getBoolOption('label'))
        .addClass('fluid', this.getBoolOption('fluid'))
        .addClass('disabled', this.getBoolOption('disabled'))
        .addClass('search type-ahead-find', this.getBoolOption('typeAheadFind'));

      if (!iconLeft) {
        this.addClass('left', !this.getBoolOption('buttonRight'));
      }

      this.ui.input.prop('readonly', this.readonly);

      this.ui.input.prop('disabled', this.getBoolOption('disabled'));

      this.addClass('action', button && button.visible);

      if (this.multiLine) {
        autosize.update(this.ui.input);
      }
    },

    onKeyCode: function(code) {
      switch (code) {
        case 13:
          if (!this.multiLine) {
            this.triggerMethod('enter');
          }
          break;
        case 27:
          this.triggerMethod('escape');
          break;
      }
    },
  });

  channel.reply('input', function() {
    return Input;
  });

  module.exports = Input;
});

